import { useState } from 'react';

const usePagination = (defaultCurrentPage = 1) => {
  const [currentPage, setCurrentPage] = useState<number>(defaultCurrentPage);
  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };

  return { currentPage, onPageChange };
};

export default usePagination;
